<div class="main-container">
    <app-web-header></app-web-header>

    @if (!is404) {
        <router-outlet />
    } @else {
        <div class="flex items-center justify-center h-full min-h-[calc(100vh-70px)]">
            <h2 class="text-[#061F4C] font-bold text-3xl">Content Not Found.</h2>
        </div>
    }
</div>
